import React from "react";
import CustomTabs from "components/Shared/CustomTabs";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useSmsProviderDetailContext } from "contexts/SmsProviderDetailContext";
import { useSearchParams } from "react-router-dom";
import CustomTabPanel from "components/Shared/CustomTabPanel";
import NoteTab from "../../Note/Notetab";
import RowsSkeleton from "components/Shared/Skeleton/RowsSkeleton";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";

const SmsProviderDetailTab = () => {
  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get("tab") || "notes";

  const { smsProviderDetail } = useSmsProviderDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: "SmsProvider",
      sourceRef: smsProviderDetail?._id,
    },
    { skip: !smsProviderDetail?._id }
  );

  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: "SmsProvider", sourceRef: smsProviderDetail?._id },
    { skip: !smsProviderDetail?._id }
  );

  const tabs = [
    {
      label: "Notes",
      value: "notes",
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {smsProviderDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="notes">
            <NoteTab
              source="SmsProvider"
              sourceRef={smsProviderDetail._id}
            />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab
              source="SmsProvider"
              sourceRef={smsProviderDetail._id}
            />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default SmsProviderDetailTab;